exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._XPiX{background:hsla(0,0%,100%,.6)}._1Ksj7{font-size:14px}._1Ksj7 ._3slx8{color:#969696}._1Ksj7 .DsKt7{margin:20px 0 25px;text-align:center}._1Ksj7 .DsKt7 span{font-size:24px;margin:0 5px}._1Ksj7 ._267rA{position:relative;width:100%;margin-bottom:20px;font-size:15px;border:1px solid #c8c8c8;border-radius:4px;background-color:hsla(0,0%,97%,.1);padding:5px}body.reader-night-mode ._1Ksj7 ._267rA{border-color:#2e2e2e}._1Ksj7 ._267rA i{font-size:18px;display:inline-block;padding:5px;vertical-align:middle}._1Ksj7 ._267rA input{width:228px;background-color:transparent}._1Ksj7 ._267rA ._3Hq0E,._1Ksj7 ._267rA input{display:inline-block;line-height:36px;height:36px}._1Ksj7 ._267rA ._3Hq0E{width:100px;font-size:13px;text-align:center;color:#fff;background-color:#3194d0;border-radius:20px}._1Ksj7 .d3TYi{pointer-events:none;opacity:.5}._1Ksj7 .herXS{height:20px}._1Ksj7 ._3vO5f{width:100%;padding:9px 18px;font-size:18px;border:none;border-radius:25px;color:#fff;background-color:#3194d0;outline:none;display:block}._1Ksj7 ._1nasb,._1Ksj7 ._3vO5f{text-align:center;cursor:pointer}._1Ksj7 ._1nasb{font-size:14px;color:#3194d0;padding:20px 0 10px}", ""]);

// exports
exports.locals = {
	"mask": "_XPiX",
	"modal-body": "_1Ksj7",
	"des": "_3slx8",
	"chanel-des": "DsKt7",
	"input-prepend": "_267rA",
	"btn-in-resend": "_3Hq0E",
	"disable": "d3TYi",
	"tip": "herXS",
	"confirm-btn": "_3vO5f",
	"switch-btn": "_1nasb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/VerifyModal/VerifyModal.scss
// module id = rzIX
// module chunks = 6